// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingIcon_loading__DDk_0","spinner-border":"LoadingIcon_spinner-border__flYw_"};